import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AuthGuard } from './auth-guard';
import { ClientAuthGuard } from "./client/client-auth-guard";

const routes: Routes = [
  {
    path: 'pages',
    loadChildren: () => import('app/pages/pages.module')
      .then(m => m.PagesModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'auth',
    loadChildren: () => import('app/auth/auth.module')
        .then(m => m.AuthModule)
  },
  {
    path: 'public',
    loadChildren: () => import('app/public/public.module')
        .then(m => m.PublicModule),
    canActivate: []
  },
  {
    path: 'client',
    loadChildren: () => import('app/client/client.module')
        .then(m => m.ClientModule),
  },
  { path: '', redirectTo: 'pages', pathMatch: 'full' },
  { path: '**', redirectTo: 'pages' }
];

const config: ExtraOptions = {
  useHash: false,
  anchorScrolling: 'enabled'
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
 